<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('fulfillments_prepaid_pendings.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right tools-view-height mx-1" color="secondary" outlined @click="downloadPendingsCSV" style="max-width: 40px !important; min-width: 40px !important" >
                                <v-icon class="px-1" small>download</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('fulfillments_cod_pendings.download') }}</span>
                    </v-tooltip>
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="openModalBulk">
                        {{ $t('fulfillments_prepaid_pendings.bulk_supply') }}
                        <v-icon class="px-1" small>add</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable show-select v-model="selected" :pagination="[10, 25, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                                <h3 class="text-uppercase">
                                    {{ $t('fulfillments_prepaid_pendings.modal.delete') }}
                                </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_prepaid_pendings.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('fulfillments_prepaid_pendings.no') }}</v-btn>
                            <v-btn color="error" @click="deleteOrder">
                                {{ $t('fulfillments_prepaid_pendings.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%"  v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_prepaid_pendings.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    
                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDetail = false">{{ $t('fulfillments_prepaid_pendings.go_back') }}</v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalBulk" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_prepaid_pendings.fill_orders') }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.orders') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ this.selected.length }} {{ $t("fulfillments_prepaid_pendings.orders_to_fill") }}</label></div>
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.select_box') }}</label></div>

                    <v-row class="px-7 py-0 mt-4" justify="center" align="center" v-if="shipping_service == 'usps'">
                        <v-col cols="12" class="py-0">
                            <v-autocomplete class="mt-0 py-0" v-model="selected_ss" :items="shipping_services" item-value="id" item-text="name" :label="$t('fulfillments_prepaid_pendings.select_ss')"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row class="px-7 py-0 mt-4" justify="center" align="center">
                        <v-col cols="12" class="py-0">
                            <v-autocomplete class="mt-0 py-0" v-model="bulk.box" :items="boxes" item-value="id" item-text="name" :label="$t('fulfillments_prepaid_pendings.box')" :rules="rules_required"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row class="px-7 py-0 mt-4" justify="center" align="center">
                        <v-col cols="12" class="py-0">
                            <v-text-field class="py-0" v-model="bulk.quantity" :label="$t('fulfillments_prepaid_pendings.boxes_per_order')" :rules="numeric_required"></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalBulk = false">{{ $t('fulfillments_prepaid_pendings.go_back') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="bulkSupply">
                                {{ $t('fulfillments_prepaid_pendings.supply') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalSupply" persistent max-width="90%" v-if="orderToShow != null">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_prepaid_pendings.order_supply') }}: {{ this.orderToShow.uon }}
                            </h4>
                        </v-row>
                    </v-card-title>

                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.street") }}</label> <label>{{ this.orderToShow.consignee.street }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    
                    <div class="marker1-1 mt-3" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_prepaid_pendings.details') }}</label></div>
                    <v-row class="mr-8 ml-6 py-0 mt-3" justify="center" align="center" v-if="shipping_service == 'usps'">
                        <v-col cols="12" class="py-0">
                            <v-autocomplete class="mt-0 py-0" v-model="selected_ss" :items="shipping_services" item-value="id" item-text="name" :label="$t('fulfillments_prepaid_pendings.select_ss')"></v-autocomplete>
                        </v-col>
                    </v-row>
                    
                    <v-row class="mr-8 ml-6 py-0 mt-3" justify="center" align="center">
                        <v-col cols="6" class="py-0">
                            <v-autocomplete class="mt-0 py-0" v-model="bulk.box" :items="boxes" item-value="id" item-text="name" :label="$t('fulfillments_prepaid_pendings.box')"></v-autocomplete>
                        </v-col>
                        <v-col cols="3" class="py-0">
                            <v-text-field class="py-0" v-model="bulk.quantity" :label="$t('fulfillments_prepaid_pendings.boxes_per_order')"></v-text-field>
                        </v-col>
                        <v-col cols="3" @click="addBox">
                            <v-row justify="end" align="end">
                                <v-btn>{{ $t("fulfillments_prepaid_pendings.add") }}</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                    <v-row class="px-0 py-0 mr-2" justify="end" align="end">
                        
                    </v-row>
                    <v-row class="px-7 py-0 my-0 py-0" justify="center" align="center">
                        <v-col cols="12" class="py-0">
                            <datatable :props="{headers:headersBoxesSelected, items: boxes_selected}" @methodHandler="methodHandler" class="py-0"></datatable>
                        </v-col>
                    </v-row>
                    

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalSupply = false">{{ $t('fulfillments_prepaid_pendings.go_back') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="orderSupply">
                                {{ $t('fulfillments_prepaid_pendings.supply') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalBulkResponses" persistent max-width="90%">
                <v-card>
                    <v-card-text>
                        <v-card flat class="mb-5">
                            <v-card-text class="py-0 my-0">
                                <v-card-title class="justify-center">
                                    <v-row align="center" justify="center">
                                        <h4 class="text-uppercase blue_accent--text py-2">
                                            {{ $t('fulfillments_cod_pendings.summary_supply') }}
                                        </h4>
                                    </v-row>
                                </v-card-title>
                                
                                <p>{{bulkProps.items.length}} {{ $t('fulfillments_prepaid_pendings.results') }}</p>
                            </v-card-text>
                            <v-simple-table v-if="bulkProps.items.length > 0" fixed-header height="300px">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th v-for="(th, key) in [$t('fulfillments_prepaid_pendings.order'), $t('fulfillments_prepaid_pendings.message')]" :key="key" class="text-left">{{ th }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in bulkProps.items" :key="i">
                                            <td>{{ item.order }}</td>
                                            <!-- <td>{{ item.status }}</td> -->
                                            <td>{{ item.message }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>

                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" class="white_highlight--text" @click="modalBulkResponses = false; index();">
                                {{ $t('fulfillments_prepaid_pendings.accept') }}
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
                <v-card>
                    <v-row align="center" justify="center" class="text-center py-8 px-10">
                        <v-col cols="12">
                            <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                        </v-col>
                    </v-row>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalParcel" persistent max-width="90%">
                <v-card >
                    <v-card-text>
                        <v-row align="center" justify="center" class="pt-3 mt-3 text-center">
                            <v-col cols="12">
                                <h3>{{ $t('fulfillments_prepaid_pendings.change_parcel') }}</h3>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col cols="10">
                                <div><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.order") }}</label> <label>{{ this.shipmentParcel.uniqueOrderNumber }}</label></div>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col cols="10">
                                <v-autocomplete class="mt-0 py-0" v-model="newParcel" :items="parcels" :label="$t('fulfillments_cod_pendings.select_parcel')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="cancelUpdateParcel()">{{ $t('fulfillments_prepaid_returns.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="updateParcel()">
                                {{ $t('fulfillments_prepaid_returns.save') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
// import JSZip from 'jszip';

import { HttpShipmentRepository } from '../../../infrastructure/shipment_repository';
import { shipmentsIndexUseCase } from '../../../application/use_cases/shipments_index_use_case';
import { shipmentsShowUseCase } from '../../../application/use_cases/shipments_show_use_case';
import { shipmentsGetAvailableShippingServicesUseCase } from '../../../application/use_cases/shipments_get_available_shipping_services_use_case';

export default {
	computed: {
        headers(){
            if(this.shipping_service != "otra"){
                return [
                    { text: this.$t('fulfillments_prepaid_pendings.order'), value: 'unique_order_number' },
                    { text: this.$t('fulfillments_prepaid_pendings.client'), value: 'client.name' },
                    { text: this.$t('fulfillments_prepaid_pendings.date'), value: 'date' },
                    { text: this.$t('fulfillments_prepaid_pendings.time'), value: 'time' },
                    { text: this.$t('fulfillments_prepaid_pendings.actions'), value: 'actions' },
                ];
            }
            else{
                return [
                    { text: this.$t('fulfillments_prepaid_pendings.order'), value: 'unique_order_number' },
                    { text: this.$t('fulfillments_prepaid_pendings.client'), value: 'client.name' },
                    { text: this.$t('fulfillments_prepaid_pendings.date'), value: 'date' },
                    { text: this.$t('fulfillments_prepaid_pendings.time'), value: 'time' },
                    { text: this.$t('fulfillments_prepaid_pendings.shipping_service'), value: 'external_shipping_service' },
                    { text: this.$t('fulfillments_prepaid_pendings.actions'), value: 'actions' },
                ];
            }
        },
        headersBulk(){
            return [
                { text: this.$t('fulfillments_prepaid_pendings.order'), value: 'order' },
                { text: this.$t('fulfillments_prepaid_pendings.status'), value: 'status' },
                { text: this.$t('fulfillments_prepaid_pendings.message'), value: 'message' }
            ];
        },
        headersBoxesSelected(){
            return [
                { text: this.$t('fulfillments_prepaid_pendings.box_name'), value: 'name' },
                { text: this.$t('fulfillments_prepaid_pendings.quantity'), value: 'quantity' },
                { text: "", value: 'actions' },
            ]
        },
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        numeric_required(){
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => !!v || this.$t('edit_appointment.validations.required_field')
            ];
        },
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            sending_data: false,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
            selected: [],
            modalDelete: false,
            modalDetail: false,
            modalBulk: false,
            modalSupply: false,
            modalAlreadyOpen: false,
            modalBulkResponses: false,
            orderToDelete: '',
            orderToShow: '',
            bulk: {
                box: '', 
                quantity: ''
            },
            boxes_selected: [],
            boxes: [],
            shipmentParcel: "",
            newParcel: "OTRA",
            modalParcel: false,
            bulkProps: {
                items: [],
                search: ""
            },
            parcels: [
                "FEDEX", "99MINUTOS", "PAQUETEXPRESS", "QUIKEN", "YEGO", "UPS", "MERQ"
            ],
            shipping_services: [],
            selected_ss: null,
        }
    },
    async mounted(){
        this.$store.state.module = "headers." + this.shipping_service + "_prepaid_pendings";
        await this.checkIfCanOpen(this.shipping_service);        
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.props.items = [];
            this.boxes = [];
            this.selected = [];
            this.selected_box = "";
            this.modalBulk = false;
            this.modalBulkResponses = false;
            this.modalSupply = false;

            this.$http.get(this.$store.state.chronosApi + 'boxes', {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data.data.forEach(x => {
                    x = x.attributes;
                    this.boxes.push(x)
                })
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })

            if(this.shipping_service.toUpperCase() == "USPS") await this.loadShippingServices();

            try{
                this.props.items = [];

                const res = await shipmentsIndexUseCase('getPendingOrders', this.props.meta.page, this.props.meta.per_page, this.props.search, this.shipping_service.toUpperCase(), 'false', this.props.sort_by, HttpShipmentRepository);
                this.props.items = res.data.data;
                this.props.meta = res.data.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadShippingServices(){
            try{
                this.props.items = [];

                const res = await shipmentsGetAvailableShippingServicesUseCase(this.shipping_service.toUpperCase(), HttpShipmentRepository);

                this.shipping_services = res.ss;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async showDetails(order){ 
            this.orderToShow = order;

            try {
                const res = await shipmentsShowUseCase(order.id, HttpShipmentRepository);

                this.orderToShow = res;
                this.modalDetail = true;
            }
            catch(e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: e.response
                }
            }
        },
        async supplyOrderModal(order){
            this.orderToShow = order;

            try {
                const res = await shipmentsShowUseCase(order.id, HttpShipmentRepository);

                this.orderToShow = res;
                this.modalSupply = true;
            }
            catch(e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: e.response
                }
            }
        },
        orderSupply: async function(){
            if(this.sending_data) return;
            this.sending_data = true;

            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            let c_boxes = [];

            this.boxes_selected.forEach(x => {
                c_boxes.push({
                    quantity: parseInt(x.quantity),
                    box_id: parseInt(x.id),
                    weight: 1.0
                })
            });

            this.boxes_selected = [];

            const shipment = {
                "shipments" :[
                    {
                        "id": this.orderToShow.id,
                        "unique_order_number": this.orderToShow.unique_order_number ?? this.orderToShow.uniqueOrderNumber,
                        "client_id": this.orderToShow.client.id,
                        "service_id": this.selected_ss,
                        "type": 'Prepaid',
                        "boxes": c_boxes
                    }
                ]
            }

            var new_shipments = await this.verifyOrders(shipment, lsToken);

            if(new_shipments.length > 0) {
                if(new_shipments.includes(this.orderToShow.unique_order_number ?? this.orderToShow.uniqueOrderNumber)){
                    this.$http.post(this.$store.state.chronosApi + 'shipment/generateLabels', shipment, {headers: {Authorization: lsToken}})
                    .then((response) => {
                        if(response.status == 200){
                            if(response.data[0].code == 200){
                                this.snackbar = {
                                    visible: true,
                                    color: 'success2',
                                    text: response.data[0].success.message
                                }
                                this.modalDetail = false;
                                this.modalSupply = false;
                                this.index();
                            }
                            else {
                                this.snackbar = {
                                    visible: true,
                                    color: 'error',
                                    text: response.data[0].fault.message
                                }
                                this.modalDetail = false;
                                this.modalSupply = false;
                                this.index();
                            } 
                        }
                        this.$store.state.loaderProps.visible = false;
                    }).catch((err) => {
                        this.snackbar = {
                            visible: true,
                            color: 'error',
                            text: err.response.data[0].message
                        }
                        this.index();
                    }).finally(() => {
                        this.sending_data = false;
                        this.$store.state.loaderProps.visible = false;
                    })
                }
                else {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('fulfillments_prepaid_pendings.already_processed')
                    }
                    this.index();
                }
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('fulfillments_prepaid_pendings.already_processed')
                }
                this.index();
            }
        },
        askDelete(order){
            this.modalDelete = true;
            this.orderToDelete = order;
        },
        deleteOrder(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.delete(this.$store.state.chronosApi + 'shipment/deleteOrder/' + this.orderToDelete.id, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.data.success == true){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('fulfillments_prepaid_pendings.deleted')
                    }
                    this.modalDelete = false;
                    this.index();
                }
                else{
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('fulfillments_prepaid_pendings.deleted_failed')
                    }
                    this.modalDelete = false;
                    this.index();
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        openModalBulk(){
            if(this.selected.length > 0){
                this.modalBulk = true;
                this.bulk.uons = this.selected;
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('fulfillments_prepaid_pendings.select_empty')
                }
            }
        },
        bulkSupply: async function(){
            this.bulkProps.items = [];
            if(this.sending_data) return;
            this.sending_data = true;

            var orders = [];
            var shipments = [];

            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            this.selected.forEach( x => {
                if(!orders.includes(x.unique_order_number)){
                    shipments.push({
                        "id": x.id,
                        "unique_order_number": x.unique_order_number,
                        "service_id": this.selected_ss,
                        "client_id": x.client.id,
                        "boxes": [
                            {
                                "quantity": parseInt(this.bulk.quantity),
                                "box_id": parseInt(this.bulk.box),
                                "weight": 1.0
                            }
                        ]
                    });
                    
                    orders.push(x.uniqueOrderNumber);
                } 
                else {
                    this.bulkProps.items.push({
                        order: x.uniqueOrderNumber,
                        status: 422,
                        message: this.$t('fulfillments_prepaid_pendings.already_processed')
                    })
                }
            });

            var new_shipments = await this.verifyOrders({ "shipments": shipments }, lsToken);

            if(new_shipments.length > 0) {
                var dif_shipments = [];
                this.selected.forEach( x => {
                    if(new_shipments.includes(x.unique_order_number)){
                        dif_shipments.push({
                            "id": x.id,
                            "unique_order_number": x.unique_order_number,
                            "client_id": x.client.id,
                            "type": x.type,
                            "boxes": {
                                "quantity": parseInt(this.bulk.quantity),
                                "box_id": parseInt(this.bulk.box),
                                "weight": 1.0
                            }
                        });
                    }
                    else {
                        this.bulkProps.items.push({
                            order: x.unique_order_number,
                            status: 422,
                            message: this.$t('fulfillments_prepaid_pendings.already_processed')
                        });
                    }
                });
                
                this.sendOrders({ "shipments": dif_shipments }, lsToken);
            }
            else {
                shipments.forEach(x => {
                    this.bulkProps.items.push({
                        order: x.unique_order_number,
                        status: 422,
                        message: this.$t('fulfillments_prepaid_pendings.already_processed')
                    })
                })
                this.modalBulkResponses = true;
                this.modalBulk = false;
                this.$store.state.loaderProps.visible = false;
            }
        },
        verifyOrders: async function(shipment, lsToken){
            const {data} = await this.$http.post(this.$store.state.chronosApi + 'shipment/validateUonsBeforeProcess', shipment, {headers: {Authorization: lsToken}})
            return data.data;
        },
        sendOrders(shipment, lsToken){
            this.$http.post(this.$store.state.chronosApi + 'shipment/generateLabels', shipment, {headers: {Authorization: lsToken}})
            .then((response) => {
                response.data.forEach(x => {  
                    if(x.code != 200){
                        this.bulkProps.items.push({
                            order: x.fault.arguments.order,
                            status: x.code,
                            message: x.fault.message
                        });
                    }  
                    else {
                        this.bulkProps.items.push({
                            order: x.success.arguments.order,
                            status: x.code,
                            message: x.success.message
                        });
                    }   
                })

                this.modalBulkResponses = true;
                this.modalBulk = false;
                this.$store.state.loaderProps.visible = false;
            }).catch((err) => {
                console.log(err);
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: err.response.data.fault.message
                }
                this.index();
            }).finally(() => {
                this.sending_data = false;
                this.$store.state.loaderProps.visible = false;
            })
        },
        checkIfCanOpen(parcel){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("fulfillment_" + parcel, Date.now())
                if(e.key == "fulfillment_" + parcel) this.modalAlreadyOpen = true;              
            }, false);
        },
        changeParcelModal(shipment){
            this.modalParcel = true;
            this.shipmentParcel = shipment;
        },
        updateParcel(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.patch(this.$store.state.chronosApi + 'shipment/update/' + this.shipmentParcel.id, { shipping_service: this.newParcel, warehouse_id: this.$store.state.warehouseId, cod: 0 }, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status === 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('edit_shipment.success')
                    }
                    this.newParcel = "";
                    this.shipmentParcel = "";
                    this.modalParcel = false;
                    this.index();
                }
            }).catch((err) => {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: err.response.data.error
                }
                // TESTORDERWITHFILES02
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        cancelUpdateParcel(){
            this.newParcel = "";
            this.shipmentParcel = "";
            this.modalParcel = false;
        },
        addBox(){
            this.boxes_selected.push({
                id: this.bulk.box,
                name: this.boxes.find(x => x.id == this.bulk.box).name,
                quantity: this.bulk.quantity
            })

            this.bulk.box = "";
            this.bulk.quantity = "";
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 

            this.index();
        },
        async downloadPendingsCSV(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            const data = await this.$http.get(this.$store.state.chronosApi + 'pending_orders/stock_allocation/export?cod=false', { headers: { Authorization: lsToken } });

            var rows = data.data.split('\n');
            var content = [];
            rows.forEach(r => {
                content.push(r.split(','));
            })

            let csvContent = "data:text/csv;charset=utf-8," + content.map(e => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var downloadLink = document.createElement("a");
            downloadLink.href = encodedUri;

            downloadLink.download = "FF_PREPAGO_Pendientes_"+ new Date().toISOString().slice(0, 10) + ".csv";
            downloadLink.click();
            this.$store.state.loaderProps.visible = false;
        },
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        },
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                if(this.modalAlreadyOpen == false) this.index();
            }, 800);
        },
    }
}
</script>

<style lang="scss">
</style>